import { QueryStringValuesAccessor } from "../query_string/QueryStringValuesAccessor";
import { WindowLocationWrapper } from "../window_wrapping/WindowLocationWrapper";
import { TrackingPermissionChecker } from "./TrackingPermissionChecker";

const LIVE_ENVIRONMENT_HOSTNAME_PARTS = [
	"www.lawdepot.",
	"www.legalcontracts.",
	"www.doculaw.com",
	"www.documentslegaux.fr",
	"www.rechtsdokumente.de",
];

export class EnvironmentTrackingPermissionChecker
	implements TrackingPermissionChecker
{
	constructor(
		private readonly windowLocation: WindowLocationWrapper,
		private readonly queryStringValuesAccessor: QueryStringValuesAccessor
	) {
		// do nothing
	}

	isTrackingEnabled(): boolean {
		return this.isLiveEnvironment() || this.isTrackingExplicitlyEnabled();
	}

	private isLiveEnvironment(): boolean {
		const hostname = this.windowLocation.hostname;
		return (
			LIVE_ENVIRONMENT_HOSTNAME_PARTS.filter((p) => hostname.includes(p))
				.length > 0
		);
	}

	private isTrackingExplicitlyEnabled() {
		return (
			String(
				this.queryStringValuesAccessor.getValueByKey("trackingEnabled")
			).toLowerCase() === "true"
		);
	}
}
